// TODO: Make MtTraceDetails use this NewTestTracesService and NewAttachmentsService
angular.module('app').factory('TestTracesService', function () {
    // Trace Details cache
    let detailsCache = [];
    let isNewDetails = false;
    let fac = {
        // TestDetails
        isNewDetails: isNewDetails,
        addToDetailsCache: addToDetailsCache,
        fetchFromDetailsCache: fetchFromDetailsCache,
        adjustToLocalTime: adjustToLocalTime,
        filterRows: filterRows,
        removeDuplicateNewRows: removeDuplicateNewRows
    };
    function addToDetailsCache(nodes) {
        let detailsTemp = detailsCache.concat(nodes);
        fac.isNewDetails = true;
        detailsCache = detailsTemp;
    }
    function fetchFromDetailsCache() {
        // let detailsTemp = detailsCache;
        let detailsTemp = angular.copy(detailsCache);
        detailsCache = [];
        fac.isNewDetails = false;
        return detailsTemp;
    }
    // Utility methods => to common methods service
    function adjustToLocalTime(nodes, timezoneOffset) {
        // Only if we have to
        if (timezoneOffset === 0) {
            return nodes;
        }
        // NOTE: Convert UTC time to local time and patch the node label
        angular.forEach(nodes, function (node) {
            try {
                let ts = moment(node.MessageTimestamp).subtract(timezoneOffset, 'm');
                let tsFormatted = ts.format('HH:mm:ss DDMMMYY');
                let label = tsFormatted + ' ' + _.drop(node.Rows[0].label.split(' '), 2)
                    .join(' ')
                    .replace(/\s+/g, ' ');
                node.Rows[0].label = label;
            }
            catch (ex) {
                // If we fail to format the timestamp then indicate with a *
                node.Rows[0].label = '* ' + node.Rows[0].label;
            }
        });
        return nodes;
    }
    // TODO: For ManagedTester we need to filter by ProjectIterationId also
    function filterRows(nodes, traceSummaryRequest) {
        let tsr = traceSummaryRequest;
        // Filter by UserId, SimId, TestSuiteId, TestId
        let isDetails = tsr.UserId > -1
            && tsr.ProjectIterationId > -1
            && tsr.SimId > -1
            && tsr.TestSuiteId > -1
            && tsr.TestId > -1;
        let traceDetailNodes = _.filter(nodes, function (node) {
            let obj = node.Rows[0];
            return obj.UserId === tsr.UserId
                && obj.ProjectIterationId === tsr.ProjectIterationId
                && obj.SimId === tsr.SimId
                && obj.SuiteId === tsr.TestSuiteId
                && obj.TestId === tsr.TestId;
        });
        return traceDetailNodes;
    }
    function removeDuplicateNewRows(newRows, existingRows) {
        let existingRowIds = _.map(existingRows, 'Id');
        let nonDuplicateNewRows = _.reject(newRows, function (newRow) {
            return _.includes(existingRowIds, newRow.Id);
        });
        return nonDuplicateNewRows;
    }
    return fac;
});
